import 'regenerator-runtime/runtime';
import React from 'react';
import { hydrate } from 'react-dom';
import { datalayerInstance } from './app/datalayer';
import loadPolyfills from '@mfe/browse-polyfill-loader';

const errorLogger = console.error;

function render(App) {
  hydrate(
    // eslint-disable-next-line no-underscore-dangle
    <App
      // eslint-disable-next-line no-underscore-dangle
      {...window.__CATEGORY_PAGE_STATE__}
      highPriorityEvents={window.gap.highPriorityEvents}
      criticalCss={[]}
      criticalResources={[]}
      datalayer={datalayerInstance()}
      errorLogger={errorLogger}
    />,
    document.getElementById('category-page')
  );
}

// eslint-disable-next-line no-underscore-dangle
loadPolyfills(window.__CATEGORY_PAGE_POLYFILL__.promisePolyfillPath)(() => {
  const App = require('./app').App;

  render(App);
});
